import { useCallback, useState } from 'react';
import { Button, Card, Form, Input, Select, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { createDiagnosis } from '../../api/diagnosis';

const INDUSTRY_OPTIONS = [
  { value: 'domestic_ecom', label: '国内电商' },
  { value: 'cross_border_ecom', label: '跨境电商' },
  { value: 'logistics', label: '物流货代' },
  { value: 'trade_manufacturing', label: '外贸制造' },
  { value: 'other', label: '其他' },
];

export default function HomePage() {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleStart = useCallback(async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);
      const d = await createDiagnosis({
        companyName: values.companyName,
        industry: values.industry,
        scale: values.scale,
        revenue: values.revenue,
        phone: values.phone,
      });
      navigate(`/diagnosis/${d.id}`);
    } catch {
      // validation error
    } finally {
      setLoading(false);
    }
  }, [form, navigate]);

  return (
    <div style={{ maxWidth: 600, margin: '40px auto' }}>
      <Card>
        <Typography.Title level={3} style={{ textAlign: 'center', marginBottom: 8 }}>
          企业数字化健康度诊断
        </Typography.Title>
        <Typography.Paragraph type="secondary" style={{ textAlign: 'center', marginBottom: 24 }}>
          共 25 题，约 10 分钟。按企业实际情况作答，支持中途退出，进度自动保存。
        </Typography.Paragraph>
        <Form form={form} layout="vertical">
          <Form.Item name="companyName" label="企业名称" rules={[{ required: true, message: '请输入企业名称' }]}>
            <Input placeholder="如：振华精密制造有限公司" />
          </Form.Item>
          <Form.Item name="phone" label="手机号" rules={[{ required: true, message: '请输入手机号' }, { pattern: /^1\d{10}$/, message: '请输入正确的手机号' }]}>
            <Input placeholder="请输入手机号" maxLength={11} />
          </Form.Item>
          <Form.Item name="industry" label="所属行业">
            <Select options={INDUSTRY_OPTIONS} placeholder="请选择行业" allowClear />
          </Form.Item>
          <Form.Item name="scale" label="员工规模">
            <Select
              options={[
                { value: '1-49', label: '1-49 人' },
                { value: '50-199', label: '50-199 人' },
                { value: '200-499', label: '200-499 人' },
                { value: '500+', label: '500 人以上' },
              ]}
              placeholder="请选择规模"
              allowClear
            />
          </Form.Item>
          <Form.Item name="revenue" label="年营收区间">
            <Select
              options={[
                { value: '<1000万', label: '1000 万以下' },
                { value: '1000万-5000万', label: '1000 万-5000 万' },
                { value: '5000万-1亿', label: '5000 万-1 亿' },
                { value: '>1亿', label: '1 亿以上' },
              ]}
              placeholder="请选择营收区间"
              allowClear
            />
          </Form.Item>
          <Form.Item style={{ marginBottom: 0 }}>
            <Button type="primary" size="large" block loading={loading} onClick={handleStart}>
              开始答题
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}
